import { z } from 'zod';
import { optionalPresentUuidString, optionalUuidString } from '../zod-helpers/index.js';
import { PRODUCT_UOM_CONVERSION_CONSTRAINTS } from './constraints.js';
export const updateProductUomConversionInputSchema = z.object({
    stateId: optionalUuidString('Invalid state selection.')
        .nullable()
        .transform((value) => (typeof value === 'string' && !value.trim() ? null : value))
        .optional(),
    uomId: optionalPresentUuidString('Invalid UOM selection.').optional(),
    ratio: z
        .number()
        .positive(`${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.label} must be greater than 0.`)
        .min(PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.min, `${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.label} must be ${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.minMessage} or greater.`)
        .max(PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.max, `${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.label} must be 1 billion or less.`)
        .optional(),
});
//# sourceMappingURL=update-input.js.map